"use strict";
// (C) 2021 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.dispatchAndWaitFor = void 0;
var tslib_1 = require("tslib");
var rootCommandHandler_1 = require("./rootCommandHandler");
/**
 * Dispatches a command and returns a promise to wait for it to get resolved.
 *
 * @param dispatch - dashboard dispatch to use
 * @param command - command to trigger and wait for resolution of
 * @returns Promise of the command resolution
 * @alpha
 */
function dispatchAndWaitFor(dispatch, command) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a, promise, envelope;
        return tslib_1.__generator(this, function (_b) {
            _a = rootCommandHandler_1.commandEnvelopeWithPromise(command), promise = _a.promise, envelope = _a.envelope;
            dispatch(envelope);
            return [2 /*return*/, promise];
        });
    });
}
exports.dispatchAndWaitFor = dispatchAndWaitFor;
//# sourceMappingURL=dispatchAndWaitFor.js.map